import { useContext, useState, useEffect } from "react";

import { getSystemNotifications } from "api/systemNotifications";
import { AuthContext } from "providers/CognitoAuthProvider";

interface MessageItem {
  type: string;
  title: string;
  body: string;
}

export const useGetSystemNotificationsApi = (): MessageItem[] => {
  const auth = useContext(AuthContext);
  const [notifications, setNotifications] = useState<MessageItem[]>([]);

  useEffect(() => {
    (async () => {
      const data = await getSystemNotifications(auth);
      const result = data.map(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) =>
          ({
            type: item.type,
            title: item.title,
            body: item.body,
          } as MessageItem)
      );
      setNotifications(result);
    })();
  }, [auth]);

  return notifications;
};
